export class LocationApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get Location of by GPS coords
     * @returns GetUserLocationResult
     * @throws ApiError
     */
    getLocationByGps({ latitude, longitude, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/location/gps',
            query: {
                'latitude': latitude,
                'longitude': longitude,
            },
        });
    }
    /**
     * Autocomplete location input
     * @returns Location
     * @throws ApiError
     */
    autocomplete({ value, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/location/autocomplete',
            query: {
                'value': value,
            },
        });
    }
    /**
     * Get all regions
     * @returns Location
     * @throws ApiError
     */
    regions() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/location/regions',
        });
    }
    /**
     * Get all cities in region
     * @returns Location
     * @throws ApiError
     */
    regionCities({ region, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/location/{region}/cities',
            path: {
                'region': region,
            },
        });
    }
    /**
     * Get top cities
     * @returns Location
     * @throws ApiError
     */
    topCities() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/location/top-cities',
        });
    }
}
